import { PhoneCall, UserPlus, Calendar, CalendarCheck, MessageSquare, Globe } from "lucide-react";

const features = [
  {
    icon: PhoneCall,
    title: "24/7 AI Voice & Chat Assistant",
    description: "Your AI receptionist answers calls and chats around the clock — evenings, weekends, and holidays. No hold times, no voicemail.",
  },
  {
    icon: UserPlus,
    title: "Smart Lead Capture",
    description: (<>Every caller's details are captured automatically — name, phone number, service, and notes. No leads fall through<br className="md:hidden" /> the cracks.</>),
  },
  {
    icon: Calendar,
    title: "Calendar Integration",
    description: "Connects to your existing calendar to check real-time availability. Offers customers open slots and avoids double-bookings.",
  },
  {
    icon: CalendarCheck,
    title: "Automated Appointment Booking",
    description: "The AI books appointments on the spot during the call, sends confirmations to customers and staff, and updates your calendar instantly.",
  },
  {
    icon: MessageSquare,
    title: "Conversation Summaries for Staff",
    description: "After every call or chat, your team gets a clear summary with customer details, requests, and any follow-up actions needed.",
  },
  {
    icon: Globe,
    title: "Multi-Language Support",
    description: "Serve customers in their preferred language. The AI receptionist detects and responds fluently in multiple languages automatically.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" data-testid="features-section" className="py-10 md:py-[85px] bg-[#F8FAFC]">
      <div className="section-container">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-medium uppercase tracking-widest text-[#3B82F6] mb-4">
            Features
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-[#0F172A] tracking-tight text-balance">
            Everything Your Front Desk{" "}
            <span className="text-[#3B82F6]">Needs, Automated</span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed lg:max-w-lg lg:mx-auto">
            A complete AI receptionist that handles the full customer journey — from first ring to booked appointment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className={`bg-white border border-slate-200 rounded-xl p-6 md:p-8 hover:border-blue-200 hover:shadow-xl hover:shadow-blue-900/5 transition-all duration-300 group card-hover`}
                data-testid={`feature-card-${index}`}
              >
                <div className="w-11 h-11 rounded-lg bg-[#3B82F6]/10 flex items-center justify-center mb-5 group-hover:bg-[#3B82F6]/15 transition-colors">
                  <Icon className="w-5 h-5 text-[#3B82F6]" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading font-semibold text-lg text-[#0F172A] mb-2 text-left">
                  {feature.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed text-left">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
